import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {LayoutHighlightedBackgroundOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-background-option';
import {LayoutHighlightedTextColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-text-color-option';
import {LayoutHighlightedBackgroundOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-background-opacity-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetNumberOfHighlightedRows} from '@Hooks/poster-editor/useGetNumberOfHighlightedRows';

interface TableHighlightOptionsProps {
  onClickHighlightedBackgroundOption(): void;
  onClickHighlightedTextOption(): void;
}

export function TableHighlightOptions({...props}: TableHighlightOptionsProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const highlightedRows = useGetNumberOfHighlightedRows();

  if (!activeItem?.isTableItem()) {
    return null;
  }

  if (activeItem?.isMenu()) {
    return null;
  }

  if (!highlightedRows) {
    return null;
  }

  return (
    <>
      <ContextualMenuHeadingOption id="table-row-styles-option" text={window.i18next.t('pmwjs_highlighted_items')} />
      <LayoutHighlightedBackgroundOption
        label={window.i18next.t('pmwjs_row_color')}
        onClickColorFill={(): void => {
          props.onClickHighlightedBackgroundOption();
        }}
      />
      <LayoutHighlightedTextColorOption
        onClickColorFill={(): void => {
          props.onClickHighlightedTextOption();
        }}
      />
      <LayoutHighlightedBackgroundOpacityOption />
    </>
  );
}
